import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { HString } from '@shared/src/datatypes/HString';
import { SaveCMRAgentEventDto } from '@shared/src/dtos/route/cmr/agent/SaveCMRAgentEventDto';
import { CMREventTypes } from '@shared/src/enums/CMREventTypes';

/**
 * Permet a un agent extern deixar un comentari a la fase. Es guarda com a event dels CMRs de la fase
 */
@Component({
    selector: 'shared-external-cmr-agent-phase-comment',
    templateUrl: './shared.external.cmr.agent.phase.comment.component.html',
    styleUrls: ['./shared.external.cmr.agent.phase.comment.component.scss']
})
export class SharedExternalCMRAgentPhaseCommentComponent {

    public static MAX_LENGTH = 255;

    constructor(public openRouteCMRController: OpenRouteCMRController) {
    }

    @Input() public phaseUUID: string;
    @Input() public agent: RouteCMRAgents;

    @Output() public done: EventEmitter<boolean> = new EventEmitter();

    public comment: string;
    public sending = false;

    public isValid(): boolean {
        return !HString.isNullOrNullString(this.comment) && this.comment.length <= SharedExternalCMRAgentPhaseCommentComponent.MAX_LENGTH;
    }

    public onSave(): void {
        if (this.sending || !this.isValid())
            return;

        this.sending = true;
        this.openRouteCMRController.saveCommentByPhaseUUID(this.phaseUUID, this.agent,
            SaveCMRAgentEventDto.build(this.comment, CMREventTypes.ECMRComment)).subscribe(data => {
                this.sending = false;
                if (data)
                    this.done.next(true);
            }, () => {
                this.sending = false;
            });
    }

}
